import ContentPostSettingsModalTab from "content/tabs/ContentPostSettingsModalTab";

class SEOSettingsTab extends ContentPostSettingsModalTab {

    buildElement() {
        let contentPost = this.contentPost;


        return (
            eotwJSXFactory('div', null, [
                eotwJSXFactory('h2', null, ["SEO Settings"]),
                eotwJSXFactory('p', null, ["The Meta Title and Meta Description are important for your search engine listings, so ensure they’re appropriate"]),
                'undefined' !== typeof this.contentPost.workingRevision.values['meta-title'] ? (
                    eotwJSXFactory('div', {class: "admin-form__row"}, [
                        eotwJSXFactory('label', {class: "admin-form__label", for: "page-meta-title"}, ["Meta Title"]),
                        eotwJSXFactory('input', {type: "text", class: "js-title admin-form__input", id: "page-meta-title", name: "meta title", value: contentPost.workingRevision.values['meta-title'], 'data-optional': true})
                    ])
                ) : undefined,
                'undefined' !== typeof this.contentPost.workingRevision.values['meta-description'] ? (
                    eotwJSXFactory('div', {class: "admin-form__row"}, [
                        eotwJSXFactory('label', {class: "admin-form__label", for: "page-meta-description"}, ["Meta Description"]),
                        eotwJSXFactory('textarea', {class: "admin-form__input admin-form__input--textarea js-description", name: "meta description", id: "page-meta-description", 'data-optional': true}, [contentPost.workingRevision.values['meta-description']])
                    ])
                ) : undefined
            ])
        );
    }


    getName() {
        return 'SEO Settings';
    }

    getValues() {
        let data = {};

        if ('undefined' !== typeof this.contentPost.workingRevision.values['meta-title']) {
            data['meta-title'] = this.$element.find(".js-title").val();
        }
        if ('undefined' !== typeof this.contentPost.workingRevision.values['meta-description']) {
            data['meta-description'] = this.$element.find(".js-description").val();
        }

        return data
    }
}

export default SEOSettingsTab;
